// extracted by mini-css-extract-plugin
export default {"head":"StageEditAttr_head__yU4Gn","back":"StageEditAttr_back__JcoB7","content":"StageEditAttr_content__CamXe","name":"StageEditAttr_name__0gSUm","items":"StageEditAttr_items__e1A81"};